"use client";

import React from "react";
import { SpacingType } from "@/types";
import { sectionVariants } from "@/types";
import { SectionWrapper } from "../components/SectionWraper";
import { Badge } from "../ui/badge";
import { EmptyResult } from "../components/EmptyResult";

interface CareerItem {
  department: string;
  job: {
    role: string;
    location: string;
    link: string;
  }[];
}

interface CareerListingProps { 
  darkMode?: boolean; 
  variant?: sectionVariants;
  spacing?: SpacingType;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  themeChangeOnScroll?: boolean;
  title?: string;
  careerItems?: CareerItem[];
  attributes?: React.HTMLProps<HTMLElement>;
}

const CareerListing = ({
  darkMode = false,
  variant = "A",
  spacing = "xlarge",
  usedInPageNav = false,
  pageNavTitle = "Career Listing",
  themeChangeOnScroll = false,
  title,
  careerItems,
  attributes,
}: CareerListingProps) => {

  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="career-listing"
      attributes={attributes}
      className="overflow-hidden"
    >   
      <div className="container" data-aos="fade-up">
        {title && (
          <div className="text-center lg:text-left">
            <h2>
              {title}
            </h2>
          </div>
        )}
        <div className="mx-auto mt-6 flex flex-col gap-16 md:mt-14">
          {careerItems && careerItems.length > 0 ? (
             careerItems?.map((careerItem: CareerItem) => (
              <div key={careerItem.department} className="grid">
                <h5 className="border-b pb-4 text-xl font-bold">
                  {careerItem.department}
                </h5>
                {careerItem.job.map((job) => (
                  <div
                    key={job.role}
                    className="flex items-center justify-between border-b py-6 gap-x-6 paragraph-lg"
                  >
                    {job.link ? (
                      <a href={job.link} className="hover:underline">
                        <span>{job.role}</span>
                      </a>
                    ) : (
                      <span>{job.role}</span>
                    )}
                    <Badge variant="outline" bold>{job.location}</Badge>
                  </div>
                ))}
              </div>
            ))
          ) : (
            <EmptyResult 
              title="There are no open roles right now." 
              description="We keep this space updated, but roles may appear on our LinkedIn page first." 
              buttonText="See roles on LinkedIn" 
              buttonOnClick={() => {window.open("https://www.linkedin.com/company/octet-finance/jobs/", "_blank")}} 
              className="py-12 md:py-30 xl:py-40"
            />
          )}
         
        </div>
      </div>
    </SectionWrapper>
  );
};

export { CareerListing };
